<template>
  <modal :title="$t('account_redesign.up_change_email')" :visible.sync='isShowDialog' width='560px'>
    <div class='warning-banner'>
      <i class='el-icon-info'></i>
      <span>{{ $t('account_redesign.up_email_change_tip') }}</span>
    </div>
    <el-form
      ref='emailForm'
      :model='emailForm'
      :rules='emailRules'
      label-width='120px'
      label-position='right'
      class='email-form'
      @submit.native.prevent
    >
      <el-form-item :label="$t('account_redesign.up_email_change_new_email')" prop='newEmail'>
        <el-input v-model.trim='emailForm.newEmail' type='email' maxlength='100'></el-input>
      </el-form-item>
      <el-form-item :label="$t('account_redesign.up_email_change_password')" prop='password'>
        <el-input v-model.trim='emailForm.password' type='password' show-password autocomplete='off'></el-input>
      </el-form-item>
    </el-form>
    <div slot='footer'>
      <el-button type='primary' @click='isShowDialog = false'>{{ $t('public.btn_close') }}</el-button>
      <el-button type='primary' :loading='submitLoading' @click='handleSubmit'>
        {{ $t('account_redesign.up_email_change_new_email') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
export default {
  props: ['isShowEmail', 'title', 'currentEmail'],
  computed: {
    isShowDialog: {
      get () {
        return this.isShowEmail
      },
      set (val) {
        this.$emit('update:isShowEmail', val)
      }
    },
    emailRules () {
      return {
        newEmail: [
          { required: true, message: this.$t('integration.email_address_cannot_be_empty'), trigger: 'blur' },
          { type: 'email', message: this.$t('integration.please_enter_the_correct_email_address'), trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              if (value && value.toLowerCase() === (this.currentEmail || '').toLowerCase()) {
                callback(new Error(this.$t('account_redesign.up_email_same_as_current')))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: this.$t('integration.please_input_a_password'), trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      submitLoading: false,
      emailForm: {
        newEmail: '',
        password: ''
      }
    }
  },
  watch: {
    isShowDialog (val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.emailForm) this.$refs.emailForm.resetFields()
        })
      }
    }
  },
  methods: {
    async handleSubmit () {
      try {
        await this.$refs.emailForm.validate()
      } catch (e) {
        return
      }
      // 将新邮箱和密码暂存到 localStorage，由 email-verify 页面负责发送验证码
      localStorage.setItem('pendingEmailChange', this.emailForm.newEmail)
      localStorage.setItem('pendingEmailPassword', this.emailForm.password)
      this.isShowDialog = false
      // 跳转到验证码页面，由该页面与后端交互
      this.$router.push('/email-verify')
    }
  }
}
</script>

<style lang='scss' scoped>
.warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;

  i {
    color: #409eff;
    font-size: 18px;
    margin-top: 2px;
  }

  span {
    color: #3375b9;
    font-size: 13px;
    line-height: 1.5;
  }
}

.email-form {
  ::v-deep .el-form-item__label {
    width: 150px !important;
    white-space: nowrap;
  }

  ::v-deep .el-form-item__content {
    margin-left: 150px !important;
  }
}
</style>
